import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isAdmin } from '../constants/roles';

// Csak superadmin (0) és admin (1) férhet hozzá
// Egyébként visszairányít a dashboard-ra
const AdminRoute = ({ children, superadminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user || !isAdmin(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (superadminOnly && user.role !== 0) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default AdminRoute;
